import { SortKeys } from '@chegg-wt/core/constants/projects'

export const ActionTypes = {
  // async delete citations constants
  DELETE_CITATIONS: 'CITATIONS/DELETE_CITATIONS',
  DELETE_CITATIONS_SUCCEEDED: 'CITATIONS/DELETE_CITATIONS_SUCCEEDED',
  DELETE_CITATIONS_FAILED: 'CITATIONS/DELETE_CITATIONS_FAILED',
  // async fetch citations constants
  FETCH_CITATIONS: 'CITATIONS/FETCH_CITATIONS',
  FETCH_CITATIONS_SUCCEEDED: 'CITATIONS/FETCH_CITATIONS_SUCCEEDED',
  FETCH_CITATIONS_FAILED: 'CITATIONS/FETCH_CITATIONS_FAILED',
  // pagination constants
  SET_CITATIONS_PAGE: 'CITATIONS/SET_CITATIONS_PAGE',
  // async fetch notes constants
  FETCH_NOTES: 'CITATIONS/FETCH_NOTES',
  FETCH_NOTES_SUCCEEDED: 'CITATIONS/FETCH_NOTES_SUCCEEDED',
  FETCH_NOTES_FAILED: 'CITATIONS/FETCH_NOTES_FAILED',
  // async add notes constants
  ADD_NOTES: 'CITATIONS/ADD_NOTES',
  ADD_NOTES_FAILED: 'CITATIONS/ADD_NOTES_FAILED',
  ADD_CITATIONS: 'CITATIONS/ADD_CITATIONS',
  ADD_CITATIONS_SUCCEEDED: 'CITATIONS/ADD_CITATIONS_SUCCEEDED',
  ADD_CITATIONS_FAILED: 'CITATIONS/ADD_CITATIONS_FAILED',
  // export citation constants
  EXPORT_CITATIONS: 'CITATIONS/EXPORT',
  EXPORT_CITATIONS_FAILED: 'CITATIONS/EXPORT_CITATIONS_FAILED',
  EXPORT_CITATIONS_SUCCEEDED: 'CITATIONS/EXPORT_CITATIONS_SUCCEEDED',
  EXPORT_TO_GOOGLE: 'CITATIONS/EXPORT_TO_GOOGLE',
  MOVE_CITATIONS: 'CITATIONS/MOVE',
  MOVE_CITATIONS_FAILED: 'CITATIONS/MOVE_CITATIONS_FAILED',
  // ui action constants
  TOGGLE_CITATION_CHECKBOX: 'CITATIONS/TOGGLE_CITATION_CHECKBOX',
  SORT_CITATIONS: 'CITATIONS/SORT_CITATIONS',
  SELECT_ALL_CITATIONS: 'CITATIONS/SELECT_ALL_CITATIONS',
  DESELECT_ALL_CITATIONS: 'CITATIONS/DESELECT_ALL_CITATIONS',
  CREATE_NEW_CITATION: 'CITATIONS/CREATE_NEW_CITATION',
  // citation menu action constants
  EDIT_CITATION: 'CITATIONS/EDIT_CITATION',
  EDIT_CITATION_ERROR: 'CITATIONS/EDIT_CITATION/ERROR',
  DELETE_ONE_CITATION: 'CITATIONS/DELETE_ONE_CITATION',
  VISIT_SOURCE_LINK: 'CITATIONS/VISIT_SOURCE_LINK',
  SET_CITATION_VALIDITY_VARIATION: 'SET_CITATION_VALIDITY_VARIATION',
} as const

export const sortOptions = [
  { id: SortKeys.ALPHABETICAL, name: 'Alphabetically' },
  { id: SortKeys.DATE_LEAST_RECENT, name: 'Least recent' },
  { id: SortKeys.DATE_MOST_RECENT, name: 'Most recent' },
]

export const sortOptionsList = [
  SortKeys.ALPHABETICAL,
  SortKeys.DATE_LEAST_RECENT,
  SortKeys.DATE_MOST_RECENT,
]
